<template>
    <div class="mt-5 row d-flex justify-content-between flex-wrap">
      <!-- 📢 Notice -->
      <v-card class="pa-4 mt-3 ml-5" style="width: 48%; min-height: 300px; border-radius: 10px;">
        <div class="notice-header">
          <h5 class="font-weight-bold mb-0 ml-5">📢 Notice</h5>
          <button v-if="isSeohan" type="button" class="add-notice-button" @click="$router.push('/notice')">Add Notice</button>
        </div>
        <v-list dense style="max-height: 50vh; overflow-y: auto;">
          <v-list-item
            v-for="(notice, index) in homeNotices"
            :key="index"
            @click="openNoticePopup(notice)"
            class="hoverable"
            style="cursor: pointer;"
          >
            <v-list-item-content>
              <v-list-item-title class="text-subtitle-2 font-weight-medium mb-1">
                [{{ formatNoticeDate(notice.SDATE) }}] {{ notice.TITLE }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-caption text-grey-darken-1">
                Date: {{ formatNoticeDate(notice.SDATE) }} &nbsp;&nbsp; | &nbsp;&nbsp;
                Author: {{ notice.WRITER }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="my-2" v-if="index !== homeNotices.length - 1" />
        </v-list>
      </v-card>
  <!-- 📅 Calendar -->
        <v-card class="pa-4 mt-3 mr-8 calendar-card" style="width: 48%; min-height: 300px;  border-radius: 10px;">
        <h5 class="font-weight-bold mb-2 ml-3">📅 Calendar</h5>
        <v-date-picker 
            v-model="today"
            color="primary"
            elevation="0"
            show-adjacent-months
            hide-header
            width="100%" 
            class="mt-3"
            
        ></v-date-picker>
        </v-card>


    </div>

  </template>
  
  
<script>
// ✅ 이거 다시 넣기 (HomePage.vue)
import { mapState } from "vuex";
import axios from "axios";

export default {
    name: 'HomePage',
    data() {
        return {
            today: new Date(), // 문자열 대신 Date 객체로 초기화
            noticeDialog: false, // 팝업 표시 여부
            homeNotices: [], // ✅ 공지사항 배열 추가
            selectedNotice: null, // ✅ 추가

        };
    },
    computed: {
        ...mapState({
            username: (state) => state.username, // Vuex에서 username 가져오기
        }),
        isSeohan() {
            return typeof this.username === 'string' && this.username.toUpperCase() === 'SEOHAN';
        },
    },
    mounted() {
      this.fetchNoticeList();
    },
    methods: {
      formatNoticeDate(value) {
        const date = String(value ?? '').trim();
        return /^\d{8}$/.test(date)
          ? `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`
          : date;
      },
      async fetchNoticeList() {
        try {
          const res = await axios.post("/api/getHomeNoticeList");
          //console.log("📢 홈 공지사항 리스트:", res.data);
          this.homeNotices = res.data.notices;
        } catch (err) {
          console.error("❌ 홈 공지사항 호출 실패:", err);
        }
      },
      openNoticePopup(notice) {
        this.selectedNotice = notice;

        const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, character => ({
          '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[character]));
        const fileIcon = '<svg class="file-icon" width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 2h7l4 4v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Z" stroke="currentColor" stroke-width="1.5"/><path d="M12 2v4h4M7 10h6M7 13h6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
        const attachments = (notice.FILES || []).filter(file => notice.GROUP_NO && file.blobName)
          .map(file => {
            const path = `/api/notice/${encodeURIComponent(notice.GROUP_NO)}/file?blobName=${encodeURIComponent(file.blobName)}`;
            const url = new URL(path, window.location.origin).href;
            return `<a class="file-link" href="${escapeHtml(url)}">${fileIcon}<span>${escapeHtml(file.name || 'file')}</span></a>`;
          })
          .join('');

        const width = 1000;
        const height = 700;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;

        const popup = window.open('', 'noticePopup', `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=no`);

        if (popup) {
          popup.document.write(`
            <html>
            <head>
              <title>📢 Notice</title>
              <style>
                body { font-family: 'Noto Sans KR', sans-serif; padding: 20px; line-height: 1.6; }
                h2 { font-size: 20px; margin-bottom: 16px; font-weight: bold; }
                table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
                td { border: 1px solid #ccc; padding: 8px 12px; vertical-align: top; }
                td:first-child { background-color: #f5f5f5; font-weight: bold; width: 100px; }
                .file-list { display: flex; flex-direction: column; gap: 6px; }
                .file-link { display: inline-flex; align-items: center; gap: 8px; color: #0066cc; text-decoration: none; overflow-wrap: anywhere; }
                .file-link:hover { text-decoration: underline; }
                .file-icon { flex: none; }
                .footer { text-align: right; margin-top: 30px; }
                button { padding: 6px 12px; font-size: 14px; background-color: #007bff; border: none; color: white; cursor: pointer; border-radius: 4px; }
              </style>
            </head>
            <body>
              <h2>📢 Notice</h2>
              <table>
                <tr><td>Title</td><td>${escapeHtml(notice.TITLE)}</td></tr>
                <tr><td>Date</td><td>${escapeHtml(this.formatNoticeDate(notice.REG_YMD))}</td></tr>
                <tr><td>Writer</td><td>${escapeHtml(notice.WRITER)}</td></tr>
                <tr><td>File</td><td>${attachments ? `<div class="file-list">${attachments}</div>` : '-'}</td></tr>
              </table>
              <p>${escapeHtml(notice.BODY).replace(/\n/g, '<br>')}</p>
              <div class="footer">
                <button onclick="window.close()">닫기</button>
              </div>
            </body>
            </html>
          `);
          popup.document.close();
        }
      },

    }


}
</script>
<style scoped>
.notice-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.add-notice-button {
  padding: 6px 12px;
  border: 0;
  border-radius: 4px;
  background-color: #007bff;
  color: #fff;
  cursor: pointer;
}

.add-notice-button:hover {
  background-color: #0056b3;
}

.custom-font {
    font-family: 'Noto Sans KR' !important;
}

.text-container {
    height: 80vh; /* 화면 높이의 50% 지점에 위치 */
    margin-left: 60vh;
    display: flex;
    justify-content: end; /* 가로 가운데 정렬 */
    align-items: center; /* 세로 가운데 정렬 */
}
.text-container2 {
    height: 1vh; /* 화면 높이의 50% 지점에 위치 */
    margin-left: 60vh;
    display: flex;
    justify-content: end; /* 가로 가운데 정렬 */
    align-items: center; /* 세로 가운데 정렬 */
}

/* 텍스트 스타일 */

@keyframes slideIn {
    from {
        opacity: 0; 
        transform: translateX(-50px); /* 왼쪽에서 시작 */
    }
    to {
        opacity: 1; 
        transform: translateX(0); /* 원래 위치로 */
    }
}

.card-equal {
  width: 19%; /* 딱 5개가 한 줄에 맞게 */
  min-width: 200px;
  margin-right: 1%;
}

@media (max-width: 1200px) {
  .card-equal {
    width: 48%;
    margin-bottom: 20px;
  }
}

@media (max-width: 600px) {
  .card-equal {
    width: 100%;
    margin-bottom: 20px;
  }
}
.chart-card {
  width: 48%;
  min-width: 250px;
  margin-bottom: 20px;
  padding: 16px !important; /* 기본 pa-5에서 줄임 */
  font-size: 0.85rem; /* 전체적으로 폰트 축소 */
}

.chart-card h5 {
  font-size: 1rem;
  margin-bottom: 12px;
}

.chart-card canvas {
  max-height: 230px; /* 그래프 크기도 약간 줄임 */
}

/* 반응형 대응 */
@media (max-width: 992px) {
  .chart-card {
    width: 100%;
  }
}

.container-fluid {
  height : 95%;
  overflow-y: auto;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../assets/fonts/HYUNDAISANSHEADKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../assets/fonts/HYUNDAISANSHEADKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../assets/fonts/HYUNDAISANSHEADKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../assets/fonts/HYUNDAISANSHEADKRLIGHT.TTF') format('truetype');
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../assets/fonts/HYUNDAISANSTEXTKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../assets/fonts/HYUNDAISANSTEXTKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../assets/fonts/HYUNDAISANSTEXTKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}

.v-picker_body {
  border: 2px solid black; /* 검은 테두리 */
  border-radius: 8px;
  overflow: hidden; /* border 넘치는 부분 정리 */
}



/* 선택된 날짜도 줄이 사라지지 않게 */
::v-deep(.v-date-picker-month__day--active) {
  border: 1px solid #000;
}
.hoverable:hover {
  background-color: #f2f2f2;
}
</style>
